import { useStaffTasksSummaryQuery } from 'core/graphql';

import { usePageVisiblePoll } from '../Meta/usePageVisiblePoll';

export interface ITaskSummary {
  openCount: number;
  overdueCount: number;
  todayCount: number;
}

const EMPTY: ITaskSummary = { openCount: 0, overdueCount: 0, todayCount: 0 };

export interface IUseTaskSummaryArgs {
  /** Группа из рейки; пусто — по всем. */
  groupId?: string;
  /** Режим «Мои задачи». */
  assigneeMe?: boolean;
  assigneeIds?: string[];
  pollInterval?: number;
}

/**
 * Счётчики задач для строки метрик командного центра (ТЗ 0063).
 *
 * Считаются СЕРВЕРОМ по той же выборке, что отдаёт лента, и потому всегда
 * совпадают со списком под ними. Прежнее число суммировалось из разбивки
 * `groupsOverview` по группам и структурно не видело задач без группы: в
 * шапке стояла «1» при девяти просроченных.
 *
 * Скоуп — намеренно только режим и группа. Глубокие фильтры панели сюда НЕ
 * идут: клик по метрике сам ставит фильтр срочности, поэтому метрика, зависящая
 * от фильтров, считала бы саму себя, а число дёргалось бы на каждую букву в
 * поиске.
 */
export const useTaskSummary = ({
  groupId,
  assigneeMe,
  assigneeIds,
  pollInterval,
}: IUseTaskSummaryArgs = {}): { summary: ITaskSummary; loading: boolean } => {
  const {
    data,
    loading,
    startPolling,
    stopPolling,
  } = useStaffTasksSummaryQuery({
    variables: {
      groupId: groupId || null,
      assigneeMe: Boolean(assigneeMe),
      assigneeIds: assigneeIds && assigneeIds.length ? assigneeIds : null,
    },
    fetchPolicy: 'cache-and-network',
  });
  usePageVisiblePoll(
    startPolling,
    stopPolling,
    pollInterval || 0,
    Boolean(pollInterval),
  );
  return {
    summary: (data?.staffTasksSummary as ITaskSummary) || EMPTY,
    loading,
  };
};
